import { defineComponent as _defineComponent } from 'vue'
import ShokurekishoJobHistoryCard from '@/components/format-edit/shokurekisho/ShokurekishoJobHistoryCard.vue'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoCareerJobHistoryCard',
  props: {
    currentCardId: null,
    basicData: null
  },
  setup(__props: any) {



const careerLead =
  '今までに在籍した会社の概要を入力しましょう。\n職種ごとに、業務の実績や参加プロジェクトの説明も追加できます。'

return { __sfc: true,careerLead, ShokurekishoJobHistoryCard }
}

})